import React, { FC } from "react";
import { AcDailyBox } from "../../components";

export const DailyBoxPage: FC = () => {
  return <AcDailyBox />;
};
